import Card from "./Card";
import CardHeader from "./CardHeader";
import CardBody from "./CardBody";
import CardFooter from "./CardFooter";

export default Card;
export { CardHeader, CardBody, CardFooter };
